import helpers from 'src/helpers'
export default {
  tableDataSales: state => {
    return state.salesList
  },
  listSalesInvoices: state => {
    return state.salesInvoiceSearchList
  },
  tableDataSalesCancellation: state => {
    return state.salesCancellationList
  },
  tableDataProductExchange: state => {
    return state.productExchangeList
  },
  tableDataAeonList: state => {
    return state.aeonPaymentList
  },
  tableDataEPPList: state => {
    return state.eppPaymentList
  },
  listProductAndKittingSearchList: state => {
    return {
      list: {
        // data: state.salesProductSearchList.data.products.data.concat(state.salesProductSearchList.data.kitting.data)
      },
    }
  },
  eppMotoApprovalResponseData: state => {
    return state.eppMotoApprovalResponse.data
  },
  eppMotoRejectionResponseData: state => {
    return state.eppMotoRejectionResponse.data
  },
  getAdditionalAttributesInvalidRowStatus: state => (key, id) => {
    let existIndex = state.cartAdditionalAttributesInCompleteIds[key].findIndex(x => x === id)
    return existIndex !== -1
  },
  cartHasIncompleteAdditionalAttributesIds: state => {
    if (
      state.cartAdditionalAttributesInCompleteIds.product_ids.length > 0 ||
      state.cartAdditionalAttributesInCompleteIds.kitting_ids.length > 0
    ) {
      return true
    }
    return false
  },
  upgradeableEnrollmentRankList: state => enrollmentTypeID => {
    if (
      state.enrollmentSalesRankList.list.data !== null &&
      state.enrollmentSalesRankList.list.data !== undefined &&
      state.enrollmentSalesRankList.list.data.length > 0
    ) {
      return state.enrollmentSalesRankList.list.data.filter(rank => {
        return rank.enrollment_type_id <= enrollmentTypeID
      })
    }
    return []
  },
  currentEnrollmentRankTierList: state => enrollmentTypeID => {
    if (
      state.enrollmentSalesRankList.list.data !== null &&
      state.enrollmentSalesRankList.list.data !== undefined &&
      state.enrollmentSalesRankList.list.data.length > 0
    ) {
      return state.enrollmentSalesRankList.list.data.filter(rank => {
        return rank.enrollment_type_id === enrollmentTypeID
      })
    }
    return []
  },
  getSaleEligibleApiErrorMsg: state => {
    return state.saleEligibleApiHasError.error
  },
  getSaleSvTransferByProductItems: state => {
    let items = helpers.getValue(state.saleSvTransfer, 'itemsInfo.data', [])
    items = items.map(item => {
      return {
        ...item,
        ...{
          quantity: item.quantity - item.quantity_transferred,
          quantity_transferred: 0,
          total_sv_transferred: 0,
          total_bv_transferred: 0,
          total_cbp_point_transferred: 0,
        },
      }
    })
    return items
  },
  getSaleSvTransferByProductItemsTotals: state => {
    let {
      total_sv = 0,
      total_bv = 0,
      total_cbp_point = 0,
      total_bv_transferred = 0,
      total_sv_transferred = 0,
      total_cbp_point_transferred = 0,
    } = state.saleSvTransfer.itemsInfo || {}
    return {
      total_sv: total_sv - total_sv_transferred,
      total_bv: total_bv - total_bv_transferred,
      total_cbp_point: total_cbp_point - total_cbp_point_transferred,
    }
  },
  getSaleSvTransferByProductDetails: state => {
    return helpers.getValue(state.saleSvTransfer, 'data', {})
  },
  tableDataRecord: state => {
    return state.recordList
  },
}
